import StickyBottomBarTrigger from "components/StickyBottomBar/StickyBottomBarTrigger";
import config from "config/config";
import { useLanguage } from "contexts/LocalizationContext";
import useDeviceSize from "hooks/useDeviceSize";
import {
  useCompanyMenu,
  useImprintMenu,
  useKnowYourRightsMenu,
  useLegalMenu,
  useProductsMenu,
  useSupportMenu,
} from "utils/menuUtils";
import { ChakraBox as Box } from "@airhelp/react-ui-components";
import FooterDesktop from "./FooterDesktop";
import FooterMobile from "./FooterMobile";
import type { MenusProps } from "./Footer.d";

const Footer = () => {
  const language = useLanguage();
  const knowYourRights = useKnowYourRightsMenu(language);
  const products = useProductsMenu(language);
  const support = useSupportMenu(language);
  const company = useCompanyMenu(language);
  const legal = useLegalMenu(language);
  const imprint = useImprintMenu(language);
  const { isDesktopXl } = useDeviceSize();

  const menus: MenusProps = {
    knowYourRights,
    products,
    support,
    company,
    legal,
    imprint,
  };

  const footerComponent = isDesktopXl ? <FooterDesktop menus={menus} /> : <FooterMobile menus={menus} />;

  return (
    <StickyBottomBarTrigger type="second">
      <Box
        background="#f4f6f9"
        bgImage={
          isDesktopXl
            ? `url(${config.staticUrl}/i/homepage/decoration-img-triangles-2.svg?updatedAt=1627464403168)`
            : "none"
        }
        bgRepeat="no-repeat"
        bgPosition="100% -350%"
      >
        {footerComponent}
      </Box>
    </StickyBottomBarTrigger>
  );
};

export default Footer;
